import React from 'react';

const DiagonalArrow = () => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M5.79069 2.5V4.28044H10.8407L2.37549 12.7375L3.62989 14L12.0951 5.53483V10.5767H13.8755V2.5H5.79069Z"
				fill="white"
			/>
		</svg>
	);
};

export default DiagonalArrow;
